const Menu = [
  {
    name: "Dashboard",
    url: "/dashboard",
    imageClass: "fa-solid a-solid fa-chart-line faicon",
  },

  {
    name: "Clayo Users",
    url: "/usersList",
    imageClass: "fa-solid fa-users faicon",
  },
  {
    name: "Viewers",
    url: "/fst-users",
    imageClass: "fa-solid fa-user-gear faicon",
  },
  {
    name: "Viewer Assignments",
    url: "/fst-assignments",
    imageClass: "fa-solid fa-user-check faicon",
  },
  {
    name: "News",
    url: "/news",
    imageClass: "fa-solid fa-newspaper faicon",
  },
  // {
  //     name: 'Get In Touch',
  //     url: '/getInTouch',
  //     imageClass: 'fa-solid fa-ticket faicon',

  // },
  // {
  //     name: 'Products',
  //     url: '/products',
  //     imageClass: 'fa-brands fa-product-hunt faicon',
  // },
  {
    name: "Faqs",
    url: "/faqs",
    imageClass: "fa-solid fa-question faicon",
  },
  {
    name: "Documents",
    url: "/documents-list",
    imageClass: "fa-solid fa-file-lines faicon",
  },
  {
    name: "Configurations",
    url: "/configurations",
    imageClass: "fa-solid fa-gear faicon",
  },

  // {
  //     name: 'Invite Friend',
  //     url: '/inviteFriend',
  //     imageClass: 'fa-solid fa-user-plus faicon',
  // },
  // {
  //   name: "Subscriptions",
  //   url: "/subscriptions",
  //   imageClass: "fa-solid fa-file-invoice faicon",
  // },
  {
    name: "Send Notifications",
    url: "/notifications",
    imageClass: "fa-solid fa-bell faicon",
  },
  // {
  //   name: "Send Emails",
  //   url: "/email-list",
  //   imageClass: "fa-solid fa-bell faicon",
  // },
  // {
  //   name: "Points",
  //   url: "/points",
  //   imageClass: "fa-solid fa-coins faicon",
  // },
  {
    name: "Dates For Your Dairy",
    url: "/dairies",
    imageClass: "fa-solid fa-calendar-days faicon",
  },
  // {
  //   name: 'Category',
  //   url: '/category',
  //   imageClass: 'fa-solid fa-table-cells-large faicon'
  // },
  {
    name: "Products",
    url: "/prod_list",
    imageClass: "fa-solid fa-layer-group faicon",
  },
  {
    name: "Share Class",
    url: "/shareclass",
    imageClass: "fa-brands fa-creative-commons-share faicon",
  },
  {
    name: "Product Performance",
    url: "/product_performance",
    imageClass: "fa-brands fa-creative-commons-share faicon",
  },
  {
    name: "App Analytics",
    url: "/analytics-usage",
    imageClass: "fa-solid fa-chart-pie faicon",
    children: [
      { name: "Dashboard", url: "/analytics-usage" },
      { name: "Connected Users", url: "/analytics-usage/users" },
      { name: "Users Map", url: "/analytics-usage/map" },
      { name: "Devices", url: "/analytics-usage/devices" },
    ],
  },
  {
    name: "API Explorer",
    url: "/api-docs",
    imageClass: "fa-solid fa-code faicon",
  },
  // {
  //   name: "Sent Notifications",
  //   url: "/sent-notifications",
  //   imageClass: "fa-brands fa-creative-commons-share faicon",
  // },
  // {
  //   name: 'Locations',
  //   url: '/locations',
  //   imageClass: 'fa-solid fa-location-dot faicon'
  // },
  // {
  //   name: 'Offers',
  //   url: '/offers',
  //   imageClass: 'fa-solid fa-tags faicon'
  // },
  // {
  //   name: 'Redemptions',
  //   url: '/redemptions',
  //   imageClass: 'fa-solid fa-tags faicon'
  // },
  // {
  //   name: 'Seeks',
  //   url: '/seeks',
  //   imageClass: 'fa-regular fa-eye faicon'
  // }
  // {
  //     name: 'Brokers',
  //     url: '/brokers',
  //     imageClass: 'fa-solid fa-file-invoice faicon',
  // },
  // {
  //     name: 'Brokers',
  //     url: '/brokers',
  //     imageClass: 'fa-solid fa-file-invoice faicon',
  // },
  // {
  //     name: 'Applications',
  //     url: '/applications',
  //     imageClass: 'fa-solid fa-file-pen faicon',
  // },
  // {
  //     name: 'Investments',
  //     url: '/investments',
  //     imageClass: 'fa-solid fa-money-bill-trend-up faicon',
  // },
];

export default Menu;
